export type IScoreSystem = { addScore(points: number): void; getScore(): number; reset(): void; };

export class ScoreSystem implements IScoreSystem {
  private score: number = 0;
  addScore(points: number): void { this.score += points; }
  getScore(): number { return this.score; }
  reset(): void { this.score = 0; }
}
